import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationES from './locales/es.json';
import translationEN from './locales/en.json';
import translationRU from './locales/ru.json';
import translationDE from './locales/de.json';
import translationFR from './locales/fr.json';
import translationAR from './locales/ar.json';
import translationNL from './locales/nl.json';
import translationIT from './locales/it.json';
import translationRO from './locales/ro.json';
import translationPL from './locales/pl.json';
import translationUK from './locales/uk.json';

const resources = {
  es: {
    translation: translationES
  },
  en: {
    translation: translationEN
  },
  ru: {
    translation: translationRU
  },
  de: {
    translation: translationDE
  },
  fr: {
    translation: translationFR
  },
  ar: {
    translation: translationAR
  },
  nl: {
    translation: translationNL
  },
  it: {
    translation: translationIT
  },
  ro: {
    translation: translationRO
  },
  pl: {
    translation: translationPL
  },
  uk: {
    translation: translationUK
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es', // Spanish by default (service is for Spain)
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

const LANGUAGE_KEY = 'onbuild_language';

// Function to get preferred language (from localStorage or browser)
export const getBrowserLanguage = () => {
  // First check localStorage
  const savedLang = localStorage.getItem(LANGUAGE_KEY);
  const supportedLanguages = ['es', 'en', 'de', 'fr', 'ru', 'uk', 'ar', 'nl', 'it', 'ro', 'pl'];
  
  if (savedLang && supportedLanguages.includes(savedLang)) {
    return savedLang;
  }
  
  // Fall back to browser language
  const navLang = navigator.language || navigator.userLanguage;
  const browserLang = navLang.toLowerCase().split('-')[0]; // 'en-US' -> 'en', 'ru-RU' -> 'ru'
  const detected = supportedLanguages.includes(browserLang) ? browserLang : 'es';
  return detected;
};

// Function to save language preference
export const saveLanguagePreference = (lang) => {
  localStorage.setItem(LANGUAGE_KEY, lang);
};

export default i18n;

